import { call, put, select, takeLatest } from 'redux-saga/effects';
import { signOutSuccess, SIGN_OUT } from '../actions/signout';
import { changeConfigChildRoute } from '../../home/actions/config';
import { setUserLogin } from '../../home/actions/loggedUser';
import { setTokens } from '../actions/token';
import { setPermissions } from '../actions/permissions';
import { signOutService } from '../services/signOut';
import { accessTokenSelector } from '../selectors/token';
import Cookies from 'js-cookie'; 
import { getDomain } from '../helpers';
import { goToLogin } from '../../app/goToLogin';

const signOutWorker = function* ({ payload: {} }) {
    try {
        const token = yield select(accessTokenSelector);
        yield call(signOutService, token);
    } catch (err) {
        // If logout endpoint fails (401, timeout, network error),
        // proceed with local cleanup anyway — the user wants to leave
    } finally {
        yield put(signOutSuccess());
        Cookies.remove('session', { domain: getDomain(), path: '/' });

        // Navegar ANTES de vaciar el store. Si se limpia primero, React
        // repinta la app entera sin usuario ni permisos --sidebar en blanco,
        // "undefined undefined" en el menu-- durante el segundo que tarda la
        // navegacion. El usuario ve la app rota justo cuando se va.
        goToLogin();

        // Faltaba el `yield put`: estas cuatro construian la accion y la
        // tiraban, asi que el logout borraba la cookie pero dejaba en redux el
        // usuario, los tokens y los permisos. Se limpian igual, ya con la
        // navegacion en curso: redux-persist los tiene en localStorage y no
        // deberian sobrevivir a un cierre de sesion.
        yield put(setTokens(null, null));
        yield put(changeConfigChildRoute());
        yield put(setUserLogin());
        yield put(setPermissions({}));
    }
}

export default [
    takeLatest(SIGN_OUT, signOutWorker)
];